function s(e) {
  function o(t) {
    try {
      return JSON.parse(t);
    } catch {
      return;
    }
  }
  function c(t) {
    try {
      return JSON.stringify(t);
    } catch {
      return "";
    }
  }
  function r() {
    try {
      const t = "__some_random_key_you_are_not_going_to_use__";
      return e.setItem(t, t), e.removeItem(t), !0;
    } catch {
      return !1;
    }
  }
  function i() {
    r() && e.clear();
  }
  function f(t) {
    if (r()) {
      const n = e.getItem(t);
      if (n)
        return o(n);
    }
    return null;
  }
  function m(t) {
    return r() ? e.key(t) : null;
  }
  function y(t) {
    r() && e.removeItem(t);
  }
  function _(t, n) {
    if (r()) {
      const u = c(n);
      u && e.setItem(t, u);
    }
  }
  return {
    getItem: f,
    setItem: _,
    removeItem: y,
    clear: i,
    key: m
  };
}
export {
  s as storageFactory
};
//# sourceMappingURL=storageFactory.js.map
